<template>
  <el-dialog
    :visible.sync="visible"
    custom-class="my-dialog-template add-product-dialog"
    @close="closeRefresh()"
    :show-close="false"
    width="1000px"
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    append-to-body
  >
    <div slot="title">
      <span class="top-title">新增产品</span>
      <!-- 新建模板的时候，关闭弹窗就删除当前模板（未点击确认）。其他情况直接关闭弹窗 -->
      <i class="el-dialog__close el-icon el-icon-close" @click="deleteDidNotSaveTemplate()" v-if="pageName == 'childTemplate'"></i>
      <i class="el-dialog__close el-icon el-icon-close" v-else @click="visible = false"></i>
    </div>
    <el-form :inline="true" :model="searchParams" class="my-form-template addProductForm">
      <el-form-item label="产品名称" prop="productName">
        <el-input type="text" v-model="searchParams.productName" placeholder="请输入产品名称" clearable></el-input>
      </el-form-item>
      <!-- 产品类型筛选：1正常产品、2协议产品 -->
      <el-form-item label="产品类型" prop="needProductAgreement">
        <el-select v-model="searchParams.needProductAgreement" placeholder="请选择类型" clearable>
          <el-option label="正常产品" value="0"></el-option>
          <el-option label="协议产品" value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button class="cxbt" type="warning" @click="search()">查询</el-button>
      </el-form-item>
    </el-form>
    <el-tabs class="template-tab" v-model="activeName" @tab-click="handleClick" v-if="nav.length > 0">
      <el-tab-pane :label="item.name" :name="item.themeId" v-for="item in nav" :key="item.themeId"></el-tab-pane>
    </el-tabs>
    <el-table
      :data="tableData"
      border
      @select="selectionChange"
      ref="multipleTable"
      @select-all="selectAll"
      row-key="id"
      class="list-table scroll-table"
      style="width: 100%"
      v-loading="listLoading"
      tooltip-effect="dark"
    >
      <!-- 仅正常产品（needProductAgreement===1）允许勾选 -->
      <el-table-column type="selection" :reserve-selection="true"></el-table-column>
      <el-table-column type="index" label="序号" width="80"></el-table-column>
      <el-table-column prop="name" label="产品名称" min-width="200" show-overflow-tooltip></el-table-column>
      <el-table-column prop="needProductAgreement" label="产品类型" min-width="100" show-overflow-tooltip>
        <template slot-scope="scope">
          <div class="tag2 blue" v-if="scope.row.needProductAgreement == 1">协议产品</div>
          <div class="tag2 green" v-else>正常产品</div>
        </template>
      </el-table-column>
      <el-table-column prop="lowPrice" :sort-method="sortByPrice" sortable label="基础价格" min-width="100" show-overflow-tooltip></el-table-column>
    </el-table>
    <div class="dialog-footer">
      <el-button type="warning" plain @click="deleteDidNotSaveTemplate()" v-if="pageName == 'childTemplate'">取消</el-button>
      <el-button type="warning" plain @click="visible = false" v-else>取消</el-button>
      <el-button type="warning" class="bgBtn" @click="save" :loading="btnLoading">确定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { pageTool } from '@/api/mixins'
export default {
  mixins: [pageTool],
  data: () => ({
    visible: false,
    activeName: '0',
    templateId: '',// 模板id
    nav: [],
    isSaveAllProduct: '',
    selectedArr: [], // 选中的产品
    btnLoading: false,
    originalProductId: [],//模版内原有的产品id
    searchParams: {
      productName: '', // 产品名称搜索词
      needProductAgreement: '' // 产品类型：1协议产品、0正常产品
    },
    lastRemoveProduct: [],
    pageName: "",
  }),
  methods: {
    open(id, originalProduct, pageName) {
      this.pageName = ''
      this.originalProductId = []
      this.btnLoading = false
      this.templateId = ''
      this.searchParams = {}
      this.selectedArr = []
      this.originalProductId = originalProduct
      this.pageName = pageName
      if (id) {
        this.templateId = id
        this.countProductByType()
        this.initListAjax('/master/productTemplate/queryProductList')
        // 监听页面刷新，刷新时直接删除当前正在编辑的模板
        window.addEventListener('beforeunload', this.deleteDidNotSaveTemplate)
      }
      this.visible = true
      this.$refs.multipleTable && this.$refs.multipleTable.clearSelection();
    },
    search() {
      this.activeName = '0'
      this.searchAjax()
      this.countProductByType()
    },
    countProductByType() {
      let param = {
        templateId: this.templateId,
        productName: this.searchParams.productName,
        needProductAgreement: this.searchParams.needProductAgreement, // 产品类型筛选条件
        queryAddible: '1' //当打开新增产品弹窗传1，查的是模板中没有的产品,否则不传,查的是模板中的产品
      }
      this.$http({
        url: '/master/productTemplate/queryProductTheme',
        type: 'put',
        params: param,
      }).then((data) => {
        this.nav = data.data
      })
    },
    deleteDidNotSaveTemplate() {
      this.$http({
        url: '/master/productTemplate/delete',
        type: 'DELETE',
        params: {
          id: this.templateId
        }
      }).then(res => {
        this.visible = false
      }).catch(e => { this.visible = false })
    },
    // 全选时重置selectedArr
    selectAll(selection) {
      this.selectedArr = selection
    },
    // 单选
    selectionChange(selection, row) {
      // console.log(selection, row)
      // let selected = []
      // if (selection.length == 0) {
      //   // selection无值，且row有值，表示取消了选中的对象，去除此对象
      //   this.selectedArr.map((item, index) => {
      //     if (item.id == row.id) {
      //       this.selectedArr.splice(index, 1)
      //     }
      //   })
      // } else {
      //   selected = [...this.selectedArr, ...selection]
      // }
      // // 过滤数组内重复的对象
      // const res = new Map();
      this.selectedArr = selection
    },
    // 设置自定义参数
    setListParams(params) {
      params.templateId = this.templateId
      params.queryAddible = '1'
      params.themeId = this.activeName == 0 ? '' : this.activeName
      params.needProductAgreement = this.searchParams.needProductAgreement // 产品类型筛选条件
      params.pageSize = 99999999
    },
    //请求回调
    listCallback(res) {
      // 如果存在搜索关键词
      if (this.searchParams.productName) {
        // 已删除的产品列表不为0，使用搜索词过滤已删除产品列表
        if (this.$store.getters.removedProduct && this.$store.getters.removedProduct.length > 0) {
          let searchRes = []
          // 已删除的产品里有包含搜索关键词的产品，过滤出来
          searchRes = this.$store.getters.removedProduct.filter(item => {
            return item.name && item.name.search(this.searchParams.productName) != -1
          })
          this.tableData = [...searchRes, ...res.data]
        } else {
          // 已删除的产品列表为0，直接使用搜索结果
          this.tableData = res.data
        }
      } else {
        // 不存在搜索关键词，将已删除的产品和不在模板里的产品合并，即为不在当前模板里的全部产品
        this.tableData = [...this.$store.getters.removedProduct, ...res.data]
      }
    },
    // 保存
    save() {
      // 如果选中的全部是暂时删除的产品，不请求接口
      let selectedAreAllDelet = this.selectedArr.every(item => {
        return this.$store.getters.removedProduct.some(v => {
          return item.id == v.id
        })
      })
      if (this.selectedArr.length > 0) {
        // 过滤掉重新被添加的产品，剩下的是最终的删除产品列表,然后更新父组件已删除数据数组
        this.lastRemoveProduct = this.$store.getters.removedProduct.filter(item => {
          return !this.selectedArr.some(ele => ele.id === item.id)
        })
        this.$store.commit('SET_REMOVEDPRODUCT', this.lastRemoveProduct)
        // 合并选中的产品的id和原有的产品id
        this.selectedArr.map((item) => {
          this.originalProductId.push(item.id)
        })
        this.originalProductId = Array.from(new Set(this.originalProductId))
        this.btnLoading = true
        if (!selectedAreAllDelet) {
          this.$http({
            url: '/master/productTemplate/saveTemplateProduct',
            type: 'PUT',
            params: {
              templateId: this.templateId,
              productIds: this.originalProductId
            }
          }).then(res => {
            if (res.httpCode == 200) {
              this.$message.success('保存成功')
              this.visible = false
              this.btnLoading = false
            }
          }).catch(e => {
            this.btnLoading = false
          })
        } else {
          this.$message.success('保存成功')
          this.visible = false
        }
      } else {
        this.$message.warning('请至少选择一款产品')
      }
    },
    closeRefresh() {
      this.$emit('reload')
      this.destroyed();
    },
    sortByPrice(obj1, obj2) {
      let val1 = obj1.lowPrice
      let val2 = obj2.lowPrice
      return val1 - val2
    },
    handleClick(val) {
      this.pageNum = 1
      this.getList()
    },
    destroyed() {
      window.removeEventListener('beforeunload', this.deleteDidNotSaveTemplate)
    }
  },
  mounted() { },
}
</script>
<style lang="scss" scoped>
.add-product-dialog {
  .el-icon {
    color: #909399;
    font-size: 16px;
    position: absolute;
    right: 16px;
    cursor: pointer;
    &:hover {
      color: #fd9201;
    }
  }
  .top-title {
    line-height: 24px;
    font-size: 18px;
    color: #303133;
  }
  .addProductForm {
    margin-bottom: 0;
  }
  .list-table {
    margin-bottom: 32px;
    ::v-deep .el-table__row {
      height: 50px;
    }
    .cell {
      line-height: 25px;
    }
    &.scroll-table {
      ::v-deep .el-table__body-wrapper {
        max-height: 275px;
        overflow-y: scroll;
      }
    }
  }
  .dialog-footer {
    margin-top: 30px;
  }
}
</style>
<style lang="scss">
</style>
